import { Alert } from '@mantine/core';
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react';

export const MatchClaimModalAlert = ({
  matchedTariffs,
}: {
  matchedTariffs: unknown[];
}) => (
  <>
    {matchedTariffs.length ? (
      <Alert
        color="yellow"
        title="Unmatched Paid Tariff"
        mt="sm"
        icon={<IconAlertTriangle size={18} />}
        data-testid="unmatched-alert"
      >
        We detected a paid tariff not present on this claim.
      </Alert>
    ) : (
      <Alert
        color="gray"
        title="No Unmatched Tariffs"
        mt="sm"
        icon={<IconCheck size={18} />}
        data-testid="no-unmatched-alert"
      >
        All paid tariffs match the claim.
      </Alert>
    )}
  </>
);
